export const AppActionType = Object.freeze({
  APP_BUSY: "App:: Set application busy",
  REMOVE_TOAST_MESSAGE: "App:: Remove toast message",
  SET_TOAST_MESSAGE: "App:: Show toast message",
  SET_DRAWER_STATE: "App:: Show/Hide Side list",
});

export const OTC = Object.freeze(["Lucira", "BinaxNOW", "QuickVue", "Ellume"]);

export const POC = Object.freeze([
  "Luminostics",
  "Genbody",
  "CareStart",
  "Visby",
]);

export const MAIL = Object.freeze(["EverlyWell", "DxTerity"]);

export const note =
  "*Tests will likely show different performance with different audiences (e.g. adults vs. children; symptomatic vs. asymptomatic). Be sure to understand how the parameters of chosen test(s) may apply to your organization (e.g. sensitivity & specificity).";
